import delay from "lodash/delay";
import ms from "ms";
export const delayFor = (delaySeconds, callback) => {
    delaySeconds.map((seconds) => delay(callback, ms(`${seconds} seconds`)));
};
export const delayForMs = (miliSeconds) => (callback) => {
    miliSeconds.map((d) => delay(callback, ms(`${d}ms`)));
};
//# sourceMappingURL=delayFor.js.map